module.exports = __webpack_public_path__ + "img/editdisableicon.112217e2.svg";